module.exports = __webpack_public_path__ + "assets/img/one-tab8-on.099a6176.png";